import { matchPath } from "react-router";
import { app_route_ids, app_route_keys } from "constants/urlPaths";
import { manage_recordings_api } from "./ManageRecordings.api";
import { RECORDING_QUERY_PARAM } from "../constants/ManageRecordings.constant";
import { useManageOfferingsStore } from "features/ManageOfferings/store/useManageOfferingsStore";
import { schedule_types_ids } from "features/Listings/constants/Listings.constants";

const manage_recordings_resourse_apis = {
  [app_route_ids[app_route_keys.manage_recordings]]: ({ pathname, params }) => {
    const matchResults = matchPath(pathname, {
      path: app_route_ids[app_route_keys.manage_recordings],
    });

    const listingUuid = matchResults?.params?.listing_uuid;

    const storeState = useManageOfferingsStore.getState();
    const currentOffering = storeState?.currentOffering;
    const currentRecordedContentDetails =
      storeState?.currentRecordedContentDetails;

    const isRecordedCourse =
      currentRecordedContentDetails?.type === schedule_types_ids.content ||
      currentOffering?.type === schedule_types_ids.content ||
      params?.filter?.is_recorded_course;

    if (params?.filter?.use_all_recordings_api) {
      const restFilter = { ...(params.filter || {}) };
      delete restFilter.is_recorded_course;
      delete restFilter.use_all_recordings_api;
      params.filter = restFilter;

      return {
        api_end_point: manage_recordings_api.get_all_recordings,
        queries: {
          [isRecordedCourse
            ? RECORDING_QUERY_PARAM.RC
            : RECORDING_QUERY_PARAM.OTHER]: listingUuid,
        },
      };
    }

    return {
      api_end_point: manage_recordings_api.get_recordings,
      queries: {
        [isRecordedCourse
          ? RECORDING_QUERY_PARAM.RC
          : RECORDING_QUERY_PARAM.OTHER]: listingUuid,
      },
    };
  },
};

export default manage_recordings_resourse_apis;
